<ng-container *ngIf="user$ | async as user; else loading">
    <div class="profile-container" style="align-items: normal;">
        <mat-card class="user-property-list-container-card" style="width: 80%;">
            <mat-card-content>
                @if (user !== undefined) {
                    <app-user-property-list [user]="user"></app-user-property-list>
                }
            </mat-card-content>
        </mat-card>
    </div>
</ng-container>

<ng-template #loading>
    <div class="profile-container center" style="align-items: normal;">
        <mat-card class="profile-card center" style="width: 80%;">
            <mat-card-content style="width: 100%;">
                <div class="loader-container">
                    <app-loader></app-loader>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>